module.exports = __webpack_public_path__ + "h5/img/back_05.cb17badf.png";